<template>
    <div>
        <img :src="branding.portraitSplashUrl" v-if="html && branding.portraitSplashUrl && $vuetify.breakpoint.name == 'xs'" style="width:100%"/>
        <img :src="branding.landscapeSplashUrl" v-if="html && branding.landscapeSplashUrl && $vuetify.breakpoint.name != 'xs'" style="width:100%"/>
        <v-card v-if="html">
            <v-card-text v-html="html"/>
            <v-card-text v-if="loggedIn">
                <div class="text-center">
                    <v-btn @click="$router.push('/locations')" class="mt-4">
                        <v-icon dark left>mdi-cart</v-icon>
                        Shop Now
                    </v-btn>
                </div>
            </v-card-text>
        </v-card>

        <v-card v-if="html && !loggedIn" class="mt-4 mb-4">
            <v-card-text class="secondary white--text text-center">
                Please login or register to continue.
            </v-card-text>
        </v-card>

        <v-card v-if="showAccessCode">
            <v-card-title class="secondary white--text">Access Code</v-card-title>
            <v-card-text>
                <p>{{errorText}}</p>
                <v-form>
                    <v-text-field type="text"
                                  @keydown="keyDownHandler"
                                  v-model="accessCode"
                                  id="accessCode"
                                  placeholder="Access Code"></v-text-field>
                </v-form>
                <v-btn @click="loadProgram" :disabled="!accessCode" color="green darken-1">OK</v-btn>
            </v-card-text>
        </v-card>

        <v-dialog max-width="290" persistent v-model="errorDialog">
            <v-card>
                <v-card-title class="error white--text">Error</v-card-title>
                <v-card-text>{{errorText}}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="errorDialog = false" color="green darken-1" text>OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>

</template>

<script>
    import api from "../services/aggrega8-api";

    export default {
        name: 'Program',
        computed: {
            apiKey: function () {
                return this.$store.state.apiKey
            },
            userDetails: function () {
                return this.$store.state.userDetails
            },
            selectedProgram: function () {
                return this.$store.state.selected
            },
            loggedIn: function () {
                return this.$store.state.loggedIn
            },
            executing: function () {
                return this.$store.state.executing
            },
            branding: function () {
                return this.$store.state.branding
            }

        },
        data: () => ({
            errorDialog: false,
            errorText: "",
            accessCode: "",
            showAccessCode: false,
            html: null
        }),
        mounted() {
            window.scrollTo(0,0)
            if (this.$route.query.accessCode) this.accessCode = this.$route.query.accessCode
            this.loadProgram()
        },
        methods: {
            keyDownHandler(k) {
                if (k.keyCode !== 13) return
                if (!this.accessCode) {
                    return
                }
                this.loadProgram()
            },
            openAccessCode() {
                this.showAccessCode = true
                this.$nextTick().then(() => {
                    let el = document.getElementById("accessCode")
                    if (el) el.focus()
                })

            },
            loadProgram() {
                this.showAccessCode = false
                this.$store.dispatch("setExecuting", true)
                let url = "/consumer/program/" + this.$route.params.id
                if (this.accessCode) url += "?accessCode=" + this.accessCode
                api.get(url).then(
                (results) => {
                    localStorage.setItem("program", this.$route.params.id);
                    if (this.loggedIn) {
                        if (results.data.authorized) this.$store.dispatch("setCurrentProgram", results.data.program)
                    }
                    else {
                        var program = results.data.program
                        program.accessCode = null
                        if (this.accessCode) program.accessCode = this.accessCode
                        this.$store.dispatch("setSelectedProgram", program)
                    }
                    this.$store.dispatch("setBranding", results.data.program.branding)
                    if (results.data.authorized) this.$router.push("/")
                    else {
                        this.errorText = results.data.message
                        this.openAccessCode()
                    }
                },
                (error) => {
                    if (error.response.status == 403) {
                        this.errorText = error.response.data.message
                        this.$store.dispatch("setBranding", error.response.data.branding)
                    }
                    else if (error.response.data.message) {
                        this.errorText = error.response.data.message
                        this.errorDialog = true
                    }
                    else {
                        this.errorText = "Error fetching program " + error.response.status
                        this.errorDialog = true
                    }

                }).then(() => {
                    this.$store.dispatch("setExecuting", false)
                })
            },

        }
    }
</script>
